import { Component, OnInit } from '@angular/core';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-lsr-participantrefer',
  templateUrl: './participant_refer.component.html',
  styleUrls: ['./participant_refer.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class ParticipantReferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.addEventListener('resize', this.resizeFunction);
    this.resizeFunction();
  }

  resizeFunction() {
    var width = window.innerWidth;
    var shareLink = document.getElementById('shareLink') as HTMLAnchorElement;

    if (width <= 768) {
      shareLink.href = "sms:?body=www.studyforchange.com";
    } else {
      shareLink.href = "mailto:?body=www.studyforchange.com";
    }
  }
}
